import { configureStore } from "@reduxjs/toolkit";
import { UserInfo } from "../models/user.model";
import userSliceReducer from "./states/user";
import tokenSliceReducer from "./states/token";
import versionReducer from "./states/versionBE";
import { TokenInfo } from "../models/token.model";

export interface AppStore {
  user: UserInfo;
  token: TokenInfo;
  version: string;
}

export default configureStore<AppStore>({
  reducer: {
    user: userSliceReducer,
    token: tokenSliceReducer,
    version: versionReducer,
  },
});
